<template>
  <div
    class="LaunchAppBottom"
    v-baidu-event-tracking="{ feature: '唤起APP', action: '底部' }"
    @click="LaunchAppBottom"
    v-if="!in_wechat && !$route.query.hide_menu"
  >
    <svg-icon :iconClass="'logoBig'"></svg-icon>
    <div class="LaunchAppBottom__line"></div>
    <div class="LaunchAppBottom__btn">{{ $t('launchApp.bottom.btn') }}</div>
  </div>

  <div
    v-baidu-event-tracking="{ feature: '唤起APP', action: '底部' }"
    style="position: fixed; left: 50%; margin-left: -131.5px"
    class="wx"
    v-else-if="in_wechat"
  >
    <div class="LaunchAppBottom">
      <svg-icon :iconClass="'logoBig'"></svg-icon>
      <div class="LaunchAppBottom__line"></div>
      <div class="LaunchAppBottom__btn">{{ $t('launchApp.bottom.btn') }}</div>
    </div>
    <wx-open-launch-app
      id="launch-btn"
      appid="wx402a2def9e9fc451"
      :extinfo="appPath"
      @launch="handleLaunch"
      @error="handleLaunchError"
      style="position: absolute; top: 0; left: 0; right: 0; bottom: 0"
    >
      <script type="text/wxtag-template">
        <style>
          .wx-btn {
            width: 100%%;
            height: 40px;
          }
        </style>
        <div class="wx-btn"></div>
      </script>
    </wx-open-launch-app>
  </div>
</template>
<script>
import { parseQueryString, isIos } from '../utils/utils'
export default {
  name: 'LaunchAppBottom',
  props: {
    slug: {
      type: String,
      default: '',
    },
  },
  computed: {
    selected_source() {
      return this.$store.state.selected_source
    },
    in_wechat() {
      return /MicroMessenger/i.test(window.navigator.userAgent)
    },
    appPath() {
      const appPath = {
        notify: 'notify',
        wechat: 'wechat_input',
        membership: 'membership?source=web',
      }
      const query = parseQueryString(window.location.href)
      let path = ''
      if (query.tag) {
        const tag = encodeURIComponent(query.tag)
        path = `tag/${tag}`
      }
      if (query.memo_id || this.slug) {
        const slug = encodeURIComponent(query.memo_id || this.slug)
        path = `memo/${slug}`
      }
      if (!query.tag && !query.memo_id && !this.slug) {
        path = appPath[this.selected_source] || 'home'
      }

      return `flomo://${path}`
    },
  },
  methods: {
    LaunchAppBottom() {
      window.location = this.appPath
      setTimeout(function () {
        if (!document.hidden) {
          window.location.href = isIos()
            ? 'https://apps.apple.com/cn/app/flomo%E6%B5%AE%E5%A2%A8-%E6%9E%81%E7%AE%80%E5%8D%A1%E7%89%87%E7%AC%94%E8%AE%B0-%E8%BD%BB%E4%BE%BF%E7%AD%BE%E4%B8%8E%E6%97%A5%E8%AE%B0%E5%A4%87%E5%BF%98/id1552314395'
            : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.flomo.app'
        }
      }, 2000)
    },
    handleLaunch(res) {
      console.log('launch app success by bottom', res)
    },
    handleLaunchError(res) {
      console.log('handleLaunchError by bottom', res)
      const url = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.flomo.app'
      window.open(url, '_blank')
    },
  },
}
</script>
<style lang="scss" scoped>
.LaunchAppBottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: var(--bgGreen);
  color: var(--memberPlanColor);
  border-radius: 100px;
  width: 263px;
  box-sizing: border-box;
  position: fixed;
  bottom: 20px;
  bottom: calc(env(safe-area-inset-bottom) + 20px);
  bottom: calc(env(safe-area-inset-bottom) + 20px);
  left: 50%;
  transform: translateX(-50%);
  font-size: 15px;
  .svg-icon {
    width: 46px;
    color: var(--memberPlanColor);
  }
  &__line {
    width: 1px;
    height: 20px;
    background-color: var(--verticalLine);
  }
  &__btn {
    font-size: 15px;
    font-weight: 600;
  }
}

.wx {
  bottom: 20px;
  bottom: calc(20px + constant(safe-area-inset-bottom));
  bottom: calc(20px + env(safe-area-inset-bottom));
  .LaunchAppBottom {
    position: unset;
    transform: unset;
  }
}
</style>
